import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = {
  key: 0,
  class: "h-5 w-5 mr-2 text-red-500",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = {
  key: 1,
  class: "h-5 w-5 mr-2 text-yellow-500",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = { class: "font-medium" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
         'p-4 mb-4 rounded-md', 
         _ctx.isError ? 'bg-red-100 text-red-800 border border-red-300' : 
                  'bg-yellow-100 text-yellow-800 border border-yellow-300'
       ])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.isError)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[1] || (_cache[1] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[2] || (_cache[2] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                }, null, -1)
              ]))),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.message), 1)
        ]),
        (_ctx.details)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.details), 1))
          : _createCommentVNode("", true),
        (_ctx.showRetryButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry'))),
                class: "px-3 py-1 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50"
              }, " Retry ")
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}